<script>
  import { onMount } from "svelte";
  import store from "storejs";
  import Overlay from "./Overlay.svelte";
  import { getSizedImageUrl } from "@shopify/theme-images";

  let shouldShowPopup;
  let settings = {
    popupId: "int-popup",
    disabledList: "au;nz",
  };

  function setBodyOverflow(overflowType) {
    document.body.style.overflow = overflowType;
  }

  function getPopupStoreKey(popupId) {
    return `sheertex-geolocation-popup-${popupId}`;
  }

  function wasPopupShownBefore(popupId) {
    return store(getPopupStoreKey(popupId)) || false;
  }

  function closePopup(popupId) {
    setBodyOverflow("auto");
    store.set(getPopupStoreKey(popupId), true);
    shouldShowPopup = false;
  }

  function visitPage(popupId) {
    store.set(getPopupStoreKey(popupId), true);
    window.open("https://sheertex.com", "_self");
  }

  /* getting geolocation from global cache */
  function getGeolocationCountryCode() {
    if (window.__shopper__ && window.__shopper__.geo) {
      return window.__shopper__.geo.country_code.trim().toLowerCase();
    }
    return null;
  }

  async function waitForCountryCode() {
    while (!getGeolocationCountryCode()) {
      await new Promise((resolve) => setTimeout(resolve, 500));
    }

    return getGeolocationCountryCode();
  }

  onMount(() => {
    if (wasPopupShownBefore(settings.popupId)) {
      return;
    }

    waitForCountryCode().then((countryCode) => {
      if (
        settings.disabledList.toLowerCase().split(";").includes(countryCode)
      ) {
        shouldShowPopup = false;
      } else {
        shouldShowPopup = true;
        setBodyOverflow("hidden");
      }
    });
  });
</script>

{#if shouldShowPopup}
  <Overlay />
  <div class="tw-absolute tw-w-full tw-z-30" style="top: 10vh;">
    <div
      class="tw-mx-auto tw-max-w-sm tw-flex tw-flex-col tw-items-center tw-whitespace-normal tw-font-serif tw-font-normal tw-text-base tw-bg-white"
      style="max-width: 28rem; text-align: center;"
    >
      <div
        class="tw-flex tw-flex-col tw-items-center tw-w-full"
        style="padding: 4rem; padding-bottom: 0; text-align: center;"
      >
        <h2>Shopping from the US, Canada, or Europe?</h2>
        <p class="tw-mt-2">
          You’ve landed on our Oceania website—click the button below to be
          redirected to our other site.
        </p>
        <div class="tw-flex tw-flex-col tw-w-full">
          <button
            class="tw-cursor-pointer tw-uppercase tw-w-full tw-my-6"
            style="background-color: #ddff98; font-weight: 500; color: black; padding: 1rem 0; letter-spacing: 0.104rem;"
            on:click={() => visitPage(settings.popupId)}>Shop Now</button
          >
          <button
            class="tw-cursor-pointer tw-underline"
            on:click={() => {
              closePopup(settings.popupId);
            }}>Stay here</button
          >
        </div>
        <p class="tw-text-xs tw-my-6">
          We ship to the US, Canada, the UK, Iceland, and the EU.
        </p>
      </div>
      <div class="tw-w-full" style="padding: 0 0.5rem 4rem 0.5rem; ">
        <img
          class="tw-p-2"
          height="45"
          src={getSizedImageUrl(
            "https://cdn.shopify.com/s/files/1/0564/5484/0502/files/US_Flag.jpg?v=1624271685",
            "150x"
          )}
          alt="US Flag"
        />
        <img
          class="tw-p-2"
          height="45"
          src={getSizedImageUrl(
            "https://cdn.shopify.com/s/files/1/0564/5484/0502/files/CA_Flag.jpg?v=1624271685",
            "150x"
          )}
          alt="CA Flag"
        />
        <img
          class="tw-p-2"
          height="45"
          src={getSizedImageUrl(
            "https://cdn.shopify.com/s/files/1/0564/5484/0502/files/UK_Flag.jpg?v=1624271819",
            "150x"
          )}
          alt="UK Flag"
        />
        <img
          class="tw-p-2"
          height="45"
          src={getSizedImageUrl(
            "https://cdn.shopify.com/s/files/1/0564/5484/0502/files/IC_Flag.jpg?v=1624271685",
            "150x"
          )}
          alt="IC Flag"
        />
        <img
          class="tw-p-2"
          height="45"
          src={getSizedImageUrl(
            "https://cdn.shopify.com/s/files/1/0564/5484/0502/files/dNa9cMbD.jpg?v=1624290516",
            "150x"
          )}
          alt="EU Flag"
        />
      </div>
    </div>
  </div>
{/if}
